export default {"src":"/_next/static/media/apartments-icon-selected.249f6994.svg","height":93,"width":91,"blurWidth":0,"blurHeight":0};